export default __webpack_public_path__ + "static/media/story-2r.4aa4687c.png";